export default "__VITE_ASSET__LVOhiP7A__"